import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { trackEvent } from "../lib/analytics";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.pathname === "/auth/callback") {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("cv_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("cv_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("cv_token", r.data.token);
    setUser(r.data.user);
    trackEvent("Login", { props: { method: "email" } });
    return r.data.user;
  };

  const register = async (email, password, name, referralCode) => {
    const r = await api.post("/auth/register", { email, password, name, referral_code: referralCode || undefined });
    localStorage.setItem("cv_token", r.data.token);
    setUser(r.data.user);
    trackEvent("Signup", { props: { method: "email", referred: referralCode ? "true" : "false" } });
    return r.data.user;
  };

  const refresh = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      return null;
    }
  };

  // Used by AuthCallback after exchanging the session_id for a session_token
  const setSession = (userObj) => setUser(userObj);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem("cv_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
